import script from "./TitleText.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleText.vue?vue&type=script&setup=true&lang=ts"

import "./TitleText.vue?vue&type=style&index=0&id=2073b244&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2073b244"]])

export default __exports__